import { InternalAxiosRequestConfig } from 'axios';
import { getAuthHeaders } from '../../common/helpers';

export function AxiosRequestInterceptor(config: InternalAxiosRequestConfig): InternalAxiosRequestConfig {
    if (config.headers.get('skipAuthHeaders')) {
        return config;
    }
    const headers = getAuthHeaders();
    Object.entries(headers).forEach(([key, value]) => {
        config.headers.set(key, value);
    });
    return config;
}
